import { any } from 'prop-types';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { isNull } from 'lodash';

const obj = {
  0: 'processing', 2: 'processing', 3: 'success', 5: 'error', 9: 'cancel', // status 为0正常状态，进行中UI为实心数字； 1 拒绝； 2取消； 3：所有流程完成
};
function UserLogs({ userLogs }) {
  function getIcon(status, index) {
    if (status === 0 || status === 2) {
      return index;
    } if (status === 5 || status === 9) {
      return <CloseOutlined />;
    }
    return <CheckOutlined />;
  }
  return (
    <div style={{ marginTop: 20 }}>
      <div className="myapplication-detail__sub-tiny-title">申请进度</div>
      <div className="major-project-timeline">
        {
          userLogs?.map((item, index) => (
            <div className={`timeline-item timeline-item-${index + 1 === userLogs.length && obj?.[item.status]}`}>
              <div className="timeline-icon">
                {
                  index + 1 === userLogs.length
                    ? (
                      <>
                        {getIcon(item.status, index + 1)}
                      </>
                    ) : <CheckOutlined />
                }
              </div>
              <div className="timeline-cont">
                <div className="timeline-title">{item.title}</div>
                <div>{item.operateTime}</div>
                <div>
                  {!isNull(item.reasonDetail) ? '备注：' : null}
                  {item.reasonDetail}
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default UserLogs;
UserLogs.propTypes = {
  userLogs: any,
};
